export default __webpack_public_path__ + "static/media/project_medmex_3.465bcdb8.png";